<template>
  <v-layout row pa-3>
    <v-flex xs12 sm12>
      <v-alert :value="noData" dismissible color="error" icon="warning" outlined
        >We can't find an invoice. Please use an invoice ID or number.</v-alert
      >
      <v-card>
        <v-toolbar text>
          <v-icon>credit_card</v-icon>
          <v-toolbar-title>Invoices</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-flex xs6>
            <v-container pa-0>
              <v-layout align-center row>
                Number per pages:
                <v-flex xs1 pa-2>
                  <v-select
                    :items="pageStepChoices"
                    v-model="pageStep"
                  ></v-select>
                </v-flex>
                <v-text-field
                  v-model="searchQuery"
                  v-on:keyup.enter="search(searchQuery)"
                ></v-text-field>
                <v-btn icon @click.stop="search(searchQuery)">
                  <v-icon>search</v-icon>
                </v-btn>
              </v-layout>
            </v-container>
          </v-flex>
        </v-toolbar>
        <v-data-table
          :headers="headers"
          :items="items"
          class="mt-1"
          hide-default-footer
          :loading="loading"
        >
          <template v-slot:item="props">
            <tr>
              <td>{{ props.item.id }}</td>
              <td>{{ props.item.number }}</td>
              <td>
                <span v-if="props.item.description" class="grey--text"
                  >Description:</span
                >
                &nbsp;
                {{ props.item.description }}
                <br v-if="props.item.description" />
                <span class="grey--text" v-if="props.item.metadata.user_id"
                  >User:</span
                >&nbsp;
                <a
                  v-if="props.item.metadata.user_id"
                  @click.stop="viewProfile(props.item.metadata.user_id)"
                  >{{ props.item.metadata.user_id }}</a
                >
                <br v-if="props.item.metadata.user_id" />
                <span v-if="props.item.metadata.operator_id" class="grey--text"
                  >Operator:</span
                >
                &nbsp;
                {{ operatorName(props.item) }}
              </td>
              <td>{{ props.item.amount_due }}</td>
              <td>{{ props.item.created | moment("YYYY-DD-MM HH:mm") }}</td>
              <td>
                <span
                  v-if="props.item.status === 'paid'"
                  class="green--text font-weight-medium"
                  >Paid</span
                >
                <span
                  v-else-if="props.item.status === 'open'"
                  class="blue--text font-weight-medium"
                  >Open</span
                >
                <span
                  v-else-if="props.item.status === 'draft'"
                  class="purple--text font-weight-medium"
                  >Draft</span
                >
                <span
                  v-else-if="props.item.status === 'uncollectible'"
                  class="orange--text font-weight-medium"
                  >Uncollectible</span
                >
                <span
                  v-else-if="props.item.status === 'void'"
                  class="grey--text font-weight-medium"
                  >Void</span
                >
                <span v-else class="red--text font-weight-medium">{{
                  props.item.status
                }}</span>
              </td>
              <td>
                <v-btn
                  text
                  small
                  v-if="props.item.invoice_pdf"
                  id="linkButton"
                  :href="props.item.invoice_pdf"
                  download
                >
                  PDF&nbsp;
                  <v-icon>cloud_download</v-icon>
                </v-btn>

                <v-btn
                  text
                  small
                  v-if="
                    props.item.status === 'paid' &&
                      props.item.post_payment_credit_notes_amount > 0
                  "
                  @click.stop="creditNotes(props.item)"
                >
                  Credit Notes&nbsp;
                  <v-icon>list</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
          <template v-slot:no-data>No data</template>
        </v-data-table>
        <v-footer>
          <v-btn text @click.stop="previousItems()">Previous</v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click.stop="nextItems()">Next</v-btn>
        </v-footer>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import fb from "@/firebase";
import { mapState, mapMutations } from "vuex";

import ProfileView from "@/views/ProfileView";

const invoices = fb.db
  .collection("stripe_invoices")
  .orderBy("created", "desc")
  .limit(10);

export default {
  components: {},
  data: () => ({
    items: [],
    lastVisible: "",
    searchQuery: "",
    noData: false,
    itemFound: {},
    pageStepChoices: [10, 20, 50, 100, 200],
    pageStep: 10,
    headers: [
      { text: "ID", value: "id", sortable: false },
      { text: "Number", value: "number", sortable: false },
      { text: "Infos", value: "infos", sortable: false },
      { text: "Amount due", value: "amount due", sortable: false },
      { text: "Created", value: "created", sortable: false },
      { text: "Status", value: "status", sortable: false },
      { text: "Actions", value: "name", sortable: false, align: "center" }
    ],
    modal: {
      name: "CreditNotesInfo",
      payload: []
    },
    loading: false
  }),
  computed: {
    ...mapState(["operators"])
  },
  firestore: {
    items: invoices
  },
  watch: {
    pageStep: function() {
      this.$bind(
        "items",
        fb.db
          .collection("stripe_invoices")
          .orderBy("created", "desc")
          .limit(this.pageStep)
      );
    },
    items(val) {
      if (val.length > 0 && val.length <= this.pageStep) {
        this.lastVisible = val[val.length - 1].created;
      }
    }
  },
  methods: {
    ...mapMutations(["setAppAlert"]),
    viewProfile(profileId) {
      console.log(profileId);
      if (profileId) {
        fb.db
          .collection("user_profiles")
          .doc(profileId)
          .get()
          .then(profile => {
            if (profile.data().created) {
              this.$modal.show(
                ProfileView,
                {
                  profile: profile.data()
                },
                {
                  height: "auto",
                  width: "90%",
                  minWidth: 500,
                  maxWidth: 900,
                  scrollable: true
                }
              );
            } else {
              this.$store.commit("setAppAlert", {
                visible: true,
                color: "error",
                text: "Profile not yet migrated!!!"
              });
            }
          });
      }
    },
    nextItems: function() {
      this.$bind(
        "items",
        fb.db
          .collection("stripe_invoices")
          .orderBy("created", "desc")
          .limit(this.pageStep)
          .startAt(this.lastVisible)
      );
    },
    previousItems: function() {
      this.$bind(
        "items",
        fb.db
          .collection("stripe_invoices")
          .orderBy("created", "desc")
          .limit(this.pageStep)
          .endAt(this.lastVisible)
      );
    },
    search: function(query) {
      this.noData = false;
      let ref = fb.db.collection("stripe_invoices");
      if (query && query.length >= 5) {
        if (query.indexOf("in_") > -1) {
          ref = ref
            .doc(query)
            .get()
            .then(doc => {
              if (doc.data()) {
                this.itemFound = doc.data();
                this.itemFound.id = doc.id;
                this.items = [this.itemFound];
              } else {
                this.noData = true;
              }
            })
            .catch(() => {
              this.noData = true;
            });
        } else {
          ref
            .where("number", "==", query)
            .get()
            .then(snapshot => {
              if (!snapshot.empty) {
                snapshot.forEach(doc => {
                  this.itemFound = doc.data();
                  this.itemFound.id = doc.id;
                });
                this.items = [this.itemFound];
              } else {
                ref
                  .where("metadata.order_number", "==", query)
                  .get()
                  .then(snapshot => {
                    if (!snapshot.empty) {
                      snapshot.forEach(doc => {
                        this.itemFound = doc.data();
                        this.itemFound.id = doc.id;
                      });
                      this.items = [this.itemFound];
                    } else {
                      ref
                        .where("metadata.order_id", "==", query)
                        .get()
                        .then(snapshot => {
                          if (!snapshot.empty) {
                            snapshot.forEach(doc => {
                              this.itemFound = doc.data();
                              this.itemFound.id = doc.id;
                            });
                            this.items = [this.itemFound];
                          } else {
                            this.noData = true;
                          }
                        })
                        .catch(() => {
                          this.noData = true;
                        });
                    }
                  })
                  .catch(() => {
                    this.noData = true;
                  });
              }
            })
            .catch(() => {
              this.noData = true;
            });
        }
      } else {
        this.$bind("items", invoices);
      }
    },
    invoicePdf: function(item) {
      window.open(item.invoice_pdf, "CNN_WindowName");
    },
    creditNotes: function(item) {
      this.modal.payload = [];
      fb.db
        .collection("stripe_credit_notes")
        .where("invoice", "==", item.id)
        .get()
        .then(snapshot => {
          snapshot.forEach(doc => {
            this.modal.payload.push(doc.data());
          });
        });
    },
    operatorName: function(item) {
      if (item.metadata.operator_id) {
        let operator = this.operators.find(function(element) {
          return element.id === item.metadata.operator_id;
        });
        if (operator !== undefined && operator.name) {
          return operator.name;
        }
        return item.metadata.operator_id;
      }
    }
  }
};
</script>
